export default __webpack_public_path__ + "static/media/panel.7bb28168.svg";